import axios from "axios";
import { SERVER_URL } from "../../../../config/env";
import authHeader from "../../../../2_ksbHub/utils/auth/auth-header";

const classService = {
  /**
   * =========================================================
   * ✅ ALL CLASSES
   * =========================================================
   */
  async getClasses() {
    const res = await axios.get(SERVER_URL + "bsz/classes", {
      headers: authHeader(),
    });

    return res.data;
  },

  /**
   * =========================================================
   * ✅ MY CLASSES
   * =========================================================
   */
  async getMyClasses() {
    const res = await axios.get(SERVER_URL + "bsz/classes/me", {
      headers: authHeader(),
    });

    return res.data;
  },

  async saveMyClasses(classIds) {
    const res = await axios.post(
      SERVER_URL + "bsz/classes/me",
      { classIds },
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },

  /**
   * =========================================================
   * ✅ CLASSES OVERVIEW
   * =========================================================
   */
  async getClassesOverview() {
    const res = await axios.get(SERVER_URL + "bsz/classes/overview", {
      headers: authHeader(),
    });

    return res.data;
  },

  /**
   * =========================================================
   * ✅ ADMIN CLASS MANAGEMENT
   * =========================================================
   */
  async saveClasses(classes) {
    const res = await axios.post(
      SERVER_URL + "bsz/admin/classes",
      { classes },
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },

  async removeUserFromClass(userId, classId) {
    const res = await axios.delete(SERVER_URL + "bsz/classes/user", {
      data: { userId, classId },
      headers: authHeader(),
    });

    return res.data;
  },
};

export default classService;
